import { render, staticRenderFns } from "./staffshopgroup.vue?vue&type=template&id=d919e9f2&scoped=true"
import script from "./staffshopgroup.vue?vue&type=script&lang=js"
export * from "./staffshopgroup.vue?vue&type=script&lang=js"
import style0 from "./staffshopgroup.vue?vue&type=style&index=0&id=d919e9f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d919e9f2",
  null
  
)

export default component.exports